import axiosClient from "./axiosClient";
import AppUtil from "../utilities/AppUtil";
import store from "store/configStore";
import { showToast } from "../store/slices/toast";
import {
  getMe
} from "store/slices/auth";
import i18next from "i18next";
import { EXCEPT_ERRORS } from "config/AppConfig";
import { DOWNLOAD_FILE_TYPES } from "config/AppConfig";
import { clearAuthData } from "store/slices/auth";
import StorageHelper from "utilities/StorageHelper";
import { SYSTEM_ROLE } from "config/AppConfig";
import AppConfig from "config/AppConfig";
// For translation
const t = i18next.getFixedT();

var isStopShowMessage401 = false;

const httpRequest = async ({
  url,
  method,
  params,
  data,
  successMessage,
  notShowIcon,
  ...rest
}) => {
  let result;
  try {
    const response = await axiosClient.request({
      url,
      method,
      params,
      data,
      ...rest,
    });
    const { headers, data: responseData } = response;
    result = AppUtil.toCamelCaseKey(responseData);
    const authInfo = StorageHelper.getLocalObject(AppConfig.STORAGE_KEYS.user) || {};
    const contentType = headers['content-type'];
    if (typeof response === 'string') {
      if (successMessage) {
        store.dispatch(
          showToast({
            type: "success",
            message: t(successMessage),
            notShowIcon: notShowIcon
          })
        );
      }
      return response;
    }
    
    if (result.status !== 200 && !DOWNLOAD_FILE_TYPES.includes(contentType)) {
      const exceptError = EXCEPT_ERRORS.filter(item => item === result.status)[0];
      if (exceptError) {
        store.dispatch(
          showToast({
            type: "danger",
            message: result.data,
            notShowIcon: notShowIcon
          })
        );
      } else {
        if (result.status === 400 && response.config.url.includes('/auth/logout')) {
          return;
        }
        // console.log(result.status);
        if (result.status === 401 || result.status === 410) {
          if (!isStopShowMessage401) {
            store.dispatch(
              showToast({
                type: "danger",
                message: t(`toast.error.${result.status}`),
                notShowIcon: notShowIcon
              })
            );
          }
          isStopShowMessage401 = true;
          setTimeout(() => {
            isStopShowMessage401 = false;
          }, 2000);
          store.dispatch(clearAuthData());
        }
        if (result.status === 368) {
          if ((window.location.pathname.includes('/admin/company/detail/')  && !response.config.url.includes('/company/on-board-feedbacks') && !response.config.url.includes('/company-user/list')
          || response.config.url.includes('/auth/login') || (response.config.url.includes('/company-user') && response.config.url.includes('/detail'))) && authInfo && (authInfo.role === SYSTEM_ROLE.SUPER_ADMIN || authInfo.role === SYSTEM_ROLE.MANAGER)) {
            store.dispatch(
              showToast({
                type: "danger",
                message: t(`toast.error.${result.status}`),
                notShowIcon: notShowIcon
              })
            );
            if (response.config.url.includes('/deactivate')) {
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
            }
          } else {
            store.dispatch(
              showToast({
                type: "danger",
                message: t(`toast.error.${result.status}`),
                notShowIcon: notShowIcon
              })
            );
          }
        }
        if (result.status !== 368) {
          if (result.status === 309) {
            if (authInfo.role === SYSTEM_ROLE.NURSE || authInfo.role === SYSTEM_ROLE.SUPPORT_WORKER) {
              store.dispatch(getMe());
            }
          }
          if (!isStopShowMessage401) {
            store.dispatch(
              showToast({
                type: "danger",
                message: t(`toast.error.${result.status}`),
                notShowIcon: notShowIcon
              })
            );
          }
        }
        if (result.status === 403 && authInfo.role === SYSTEM_ROLE.COMPANY && !response.config.url.includes('forgot-password') && !response.config.url.includes('add-worker-to-job') && 
        !response.config.url.includes('remove-worker') && !response.config.url.includes('calculate-price') && !response.config.url.includes('/company-user/') &&
        !response.config.url.includes('job/delete') && !response.config.url.includes('/coordinator/participant/list') && !response.config.url.includes('worker/workers-applied') && !response.config.url.includes('/support/update/')) {
        // console.log(response.config.url);
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
        if (result.status === 403 && authInfo.role === SYSTEM_ROLE.MANAGER && (response.config.url === ('/dashboard') || 
        response.config.url === ('/admin') || response.config.url === ('/company') || response.config.url === ('/subscription'))) {
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
      }

      // if (result.status === 403) {
      //   return result.status;
      // } else {
        return;
      // }
    }
    if (successMessage) {
      store.dispatch(
        showToast({
          type: "success",
          message: t(successMessage),
          notShowIcon: notShowIcon
        })
      );
    }
    return result;
  } catch (error) {
    // console.log('error', error);
    const exceptError = EXCEPT_ERRORS.filter(item => item === error.status)[0];
    if (exceptError) {
      store.dispatch(
        showToast({
          type: "danger",
          message: error.data,
          notShowIcon: notShowIcon
        })
      );
    } else {
      if (error.status === 401) {
        if (!isStopShowMessage401) {
          store.dispatch(
            showToast({
              type: "danger",
              message: t(`toast.error.${result.status}`),
              notShowIcon: notShowIcon
            })
          );
        }
        isStopShowMessage401 = true;
        setTimeout(() => {
          isStopShowMessage401 = false;
        }, 2000);
        await store.dispatch(getMe());
      }
      if (error.status === 403) {
        console.log("checj");
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000);
      }
      if (!isStopShowMessage401) {
        store.dispatch(
          showToast({
            type: "danger",
            message: error.message,
            notShowIcon: notShowIcon
          })
        );
      }
    }
    return;
  }
};

export default httpRequest;
